<template>
  <div class="statistics-wrapper">
    <div class="statistics-box">
      <div
        class="statistics-title"
        v-show="statisticsList.filter((m) => m.specialType === 1).length > 0"
      >
        <i> </i>视频学习进度
      </div>
      <ul class="statistics-body video">
        <li
          v-for="(item, index) in statisticsList.filter(
            (m) => m.specialType === 1
          )"
          :key="index"
        >
          <div class="statistics-item-content">
            <div class="statistics-item-name">{{ item.specialName }}</div>
            <div class="statistics-item-circle">
              <i-circle
                :percent="item.pptFinishRate > 100 ? 100 : item.pptFinishRate"
                :stroke-width="8"
                :trail-width="6"
                :stroke-color="index == 0 ? '#27a4ff' : '#ff9e67'"
              >
                <span>{{ item.pptFinishRate }}%</span>
              </i-circle>
            </div>
            <div class="statistics-item-progress">
              学习进度：<span
                :style="index == 0 ? 'color:#27a4ff' : 'color:#ff9e67'"
                >{{ item.pptfinishNum }}</span
              >/{{ item.pptNum }}
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="statistics-box">
      <div class="statistics-title"><i> </i>题库学习进度</div>
      <ul class="statistics-body exercise">
        <li
          v-for="(item, index) in statisticsList.filter(
            (m) => m.specialType > 1
          )"
          :key="index"
        >
          <template v-if="item.specialType == 3">
            <div class="statistics-item-name">
              <div class="name-icon">
                <img
                  src="../../../assets/images/v3/study-statistics-icon01.png"
                />
              </div>
              <div class="name-text">
                {{ item.specialName }}
              </div>
            </div>
            <div class="statistics-item-content">
              <div class="statistics-item-progress">
                <div class="progress-item">
                  <p>
                    <span>{{ item.examFinishNum }}</span
                    >/{{ item.examAmountNum }}
                  </p>
                  <p>学习进度/题</p>
                </div>
                <div class="progress-item">
                  <p>
                    <span>{{ item.examCorrectRate }}</span
                    >%
                  </p>
                  <p>正确率</p>
                </div>
              </div>
            </div>
          </template>
          <template v-else-if="item.specialType == 4">
            <div class="statistics-item-name">
              <div class="name-icon">
                <img
                  src="../../../assets/images/v3/study-statistics-icon02.png"
                />
              </div>
              <div class="name-text">
                {{ item.specialName }}
              </div>
            </div>
            <div class="statistics-item-content">
              <div class="statistics-item-progress">
                <div class="progress-item">
                  <p>
                    <span>{{ item.simExamFinishNum }}</span
                    >/{{ item.simExamItem }}
                  </p>
                  <p>学习进度/套</p>
                </div>
                <div class="progress-item">
                  <p>
                    <span>{{ item.simExamAverageScore }}</span>
                  </p>
                  <p>平均分</p>
                </div>
              </div>
            </div>
          </template>
          <template v-else-if="item.specialType == 2">
            <div class="statistics-item-name">
              <div class="name-icon">
                <img
                  src="../../../assets/images/v3/study-statistics-icon03.png"
                />
              </div>
              <div class="name-text">
                {{ item.specialName }}
              </div>
            </div>
            <div class="statistics-item-content">
              <div class="statistics-item-progress">
                <div class="progress-item">
                  <p>
                    <span>{{ item.examFinishNum }}</span
                    >/{{ item.examAmountNum }}
                  </p>
                  <p>学习进度/题</p>
                </div>
                <div class="progress-item">
                  <p>
                    <span>{{ item.reviewExerCorrectRate }}</span
                    >%
                  </p>
                  <p>正确率</p>
                </div>
              </div>
            </div>
          </template>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { siteMixin } from "../../../utils/mixin";
import { study } from "../../../request";
export default {
  mixins: [siteMixin],
  data() {
    return {
      statisticsList: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      study
        .getStudyStatistics(this.loginUser.userId, this.courseId)
        .then((res) => {
          //console.log(res);
          if (res.status === 1) {
            this.statisticsList = res.data;
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.statistics-wrapper {
  .statistics-box {
    margin-bottom: 20px;
    .statistics-title {
      font-size: 24px;
      font-weight: bold;
      margin: 30px 0;
      i {
        display: inline-block;
        vertical-align: -0.26em;
        width: 4px;
        height: 28px;
        background: linear-gradient(#2da6fe, #2680fa);
        margin-right: 12px;
      }
    }
    .statistics-body {
      display: flex;
      flex-wrap: wrap;
      &.video {
        li {
          margin-right: 30px;
          background: url("../../../assets/images/v3/study-statistics-bg.png")
            no-repeat center;
        }
      }
      &.exercise {
        li {
          margin-right: 30px;
          .statistics-item-name {
            width: 100%;
            display: flex;
            align-items: center;
            .name-icon {
              width: 64px;
              height: 64px;
              margin-right: 10px;
            }
            .name-text {
              font-size: 20px;
              color: #666;
            }
          }
        }
      }
      li {
        width: 350px;
        border-radius: 6px;
        box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
        margin-bottom: 20px;
        padding: 25px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .statistics-item-content {
          flex: 1;
          .statistics-item-name {
            font-size: 20px;
            color: #666;
          }
          .statistics-item-progress {
            margin-top: 10px;
            color: #666;
            font-size: 20px;
            text-align: center;
            .progress-item {
              width: 150px;
              display: inline-block;
              & + .progress-item {
                border-left: 1px solid #c4c4c4;
              }
              p {
                &:first-child {
                  font-size: 16px;
                  span {
                    font-size: 30px;
                    color: #333;
                  }
                }
              }
            }
          }
          .statistics-item-circle {
            width: 100%;
            padding: 40px 0 0 0;
            text-align: center;
            span {
              font-size: 20px;
              color: #666;
            }
          }
        }
      }
    }
  }
}
</style>